import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import closeIcon from "../../../../src/assests/img/close-icon.svg";
import AuthManager from "../../../Common/AuthManager";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import "./RulesLog.css";
import SkeletonElement from "../../GMS/Category/Shimmer/SkeletonElement";
// import { sortTheLogs } from "Common/HelperClass";
const API_URL = process.env.REACT_APP_GMS_BACKEND_API_URL;

const RulesLogs = ({ logData, setViewLog, logId }) => {
  const [log, setLog] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // const sortedLogs = sortTheLogs(logData).split("\n\n");
    if(logData){
      const sortedLogs = logData?.split("\n\n").reverse()??[];
      setLog(sortedLogs);
    }
  }, [logData]);

  const fetchLog = async () => {
    setLoading(true);

    let res = await ServiceWrapper.doGet(
      `${API_URL}rule_queue/${logId}`,
      null,
      null,
      AuthManager.getGmsToken()
    );

    if (res?.data?.done) {
      const logsString = res.data.data?.logs;
      // const sortedLogs = sortTheLogs(logsString).split("\n\n");
      const sortedLogs = logsString?.split("\n\n").reverse()??[];
      setLog(sortedLogs);
    } else {
      toast.error("Log fetch failed.");
    }

    setLoading(false);
  };

  return (
    <div className="ps-0 tw-z-50 form-header">
      <div className="connection-container d-flex justify-content-between pe-3 ps-3">
        <span className="connection-text align-self-center fs-5  mb-0">
          Logs
          <button
            type="button"
            className="btn btn-light btn-sm"
            style={{
              color: "#091caa",
              background: "none",
              border: "none",
              boxShadow: "none",
            }}
            onClick={() => fetchLog()}
          >
            <i className="fa fa-sync-alt" />
          </button>
        </span>
        <button
          className="align-self-center border-0 btn fw fw-light mb-1 me-1 shadow-none"
          onClick={() => {
            setViewLog(false);
          }}
        >
          <img src={closeIcon} alt="Close icon" />
        </button>
      </div>

      <div className="w-100 rounded border-top">
        {loading ? (
          <div className="p-3 border-bottom">
            <SkeletonElement type="title" />
          </div>
        ) : (
          log.map((logitem, index) => {
            return (
              <div className="p-3 w-100 border-bottom" key={index}>
                <p className="text-break text-wrap">{logitem}</p>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default RulesLogs;
